import { colors } from '~/styles/colors';

export const mapColors = {
  background: '#E4E4E4',
  foreground: colors.brand.primary.dark,
};
